export default __webpack_public_path__ + "static/media/Mastercard.2bd34028.svg";